const formatter = require('./formatter')
const dom = require('./dom')
const color = require('./color')

module.exports = {
  formatter,
  dom,
  color
}
